export const getFilterById = (filters, id) => filters.find((filter) => filter.id === id);
